import useSWR from "swr";


export type StaffScores = {
  'id': string,
  'title': string,
  'survey_answer_scores_count': number,
  'survey_answer_scores_average': number,
  'survey_answer_scores_5_count': number,
  'survey_answer_scores_5_percentage': number,
  'survey_answer_scores_4_count': number,
  'survey_answer_scores_4_percentage': number,
  'survey_answer_scores_3_count': number,
  'survey_answer_scores_3_percentage': number,
  'survey_answer_scores_2_count': number,
  'survey_answer_scores_2_percentage': number,
  'survey_answer_scores_1_count': number,
  'survey_answer_scores_1_percentage': number,
}[]
export const useFetchStaffScores = (staffId?: string, queryParams?: URLSearchParams) => {
  const fetchKey = staffId ? `restaurant_staff/staff/${staffId}/survey/scores/${queryParams?.toString() && `?${queryParams}`}` : null;
  const { data: staffScores, error, isLoading } = useSWR<StaffScores>(fetchKey)
  return { staffScores, isLoading, error };
};